import { useEffect, useState } from 'react';
import { Auth0Message } from './types';

export function Auth0RedirectHandler() {
  const [messageSent, setMessageSent] = useState(false);

  useEffect(() => {
    const message = buildAuth0Message();
    Office.context.ui.messageParent(JSON.stringify(message));
    setMessageSent(true);
  }, []);

  return messageSent ? thanksForLoggingIn() : stillLoading();
}

const stillLoading = () => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <p className="text-gray-700">Loading...</p>
      <p className="text-gray-700">Do not close this window yet.</p>
    </div>
  );
};

const thanksForLoggingIn = () => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <p className="text-gray-700">Thanks for logging in!</p>
      <p className="text-gray-700">You can close this window.</p>
    </div>
  );
};

const buildAuth0Message = (): Auth0Message => {
  const hash = window.location.hash.substring(1);
  const params = new URLSearchParams(hash);

  const accessToken = params.get('access_token') || '';
  const idToken = params.get('id_token') || '';
  const state = params.get('state') || '';

  return {
    accessToken,
    idToken,
    state,
    hash,
  };
};
